import Vue from 'vue'
import store from '../store/index'
// 公用方法文件

let methods = {
  // 复制
  $copy: (copyText) => {
    Vue.nextTick(() => {
      let copyContainer = document.createElement('input')
      copyContainer.style.opacity = 0
      copyContainer.style.position = 'absolute'
      copyContainer.style.left = '-999px'
      document.body.appendChild(copyContainer)
      copyContainer.value = copyText
      copyContainer.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
    })
  },
  // 根据平台id匹配平台名称
  $getPlatformName: (id) => {
    let platformList = store.state.Auth.specialPlatformList
    let currentItem = platformList.find(item => item.id === id)
    if (currentItem) {
      return currentItem.name || ''
    }
  }
}

export default function globalMethod (app) {
  Object.keys(methods).forEach(key => {
    app.prototype[key] = methods[key]
  })
}



// WEBPACK FOOTER //
// ./src/global/method.js